<template>
    <div class="hero-home-wrapper">
        <Carousel :items-to-show="1" :mouseDrag="false" :wrapAround="true" :autsoplay="6000" :autoplay="10000">
            <slide v-for="(item, index) in banners" :key="index" class="hero-home-slider__item"
                :class="{isDark: item.isDark}" v-html="item.html" style="width:100%"
                :style="`background-image: url(`+item.banner+`)`"></slide>
            <template #addons v-if="banners.length > 1">
                <Navigation />
            </template>
        </Carousel>
    </div>
</template>
<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Navigation } from 'vue3-carousel';

export default {
    props: {
        banners: Object,
    },
    components: {
        Carousel,
        Slide,
        Navigation,
    },
}
</script>
<style>
.carousel {
    text-align: initial;
    border-bottom: 1px solid #d1d1d1;
}

.hero-home-slider__item {
    align-items: center;
    display: -ms-flexbox;
    display: flex;
}

.hero-home-slider__item h2 {
    line-height: 1em;
    font-size: 2em;
}

.carousel__next {
    right: 30px !important;
}

.carousel__prev {
    left: 30px !important;
}

.carousel__next,
.carousel__prev {
    background-color: #333 !important;
    zoom: 1.5 !important;
}

.hero-home-slider__item::before {
    background-color: rgba(255, 255, 255, 0.5) !important;
}

h1 {
    font-size: 30px;
    line-height: 39px;
}

.hero-home-slider__leyenda .triangulo {
    float: right;
    width: 40%;
    height: 100%;
    background-color: #444;
}

/*Left pointing*/

.hero-home-slider__leyenda.blanco {
    border-color: #fff;
}

.hero-home-slider__leyenda.etiqueta-amarilla::after {
    background-image: url(/img/etiqueta-amarilla.png);
}

.hero-home-slider__leyenda.etiqueta-gris::after {
    background-image: url(/img/etiqueta-gris.png);
}

.hero-home-slider__leyenda.etiqueta-blanca::after {
    background-image: url(/img/etiqueta-blanca.png);
}

.hero-home-slider__item.isDark::before {
    background-color: rgb(0 0 0 / 50%) !important;
}

.italic {
    font-family: "Playfair Display", Georgia, serif;
    font-weight: normal;
}

.boton-negro {
    font-family: "Playfair Display", Georgia, serif;
    font-style: italic;
    font-weight: 500;
    border-radius: 7px;
    color: #fff;
    display: inline-block;
    font-size: 18px;
    line-height: 24px;
    padding: 12px 20px 15px;
    transition: 0.5s;
    text-align: center;
    transition: 0.5s;
    background-color: #2d2a26;
    border: 2px solid #2d2a26;
}

.boton-negro::after {
    background-image: url(/img/icono-flecha-derecha-blanco.svg);
}

.boton-negro:hover,
.boton-negro:focus {
    background-color: rgba(51, 158, 136, 0);
    color: #000000;
}

.boton-negro:hover::after,
.boton-negro:focus::after {
    background-image: url(/img/icono-flecha-derecha-negro.svg);
}

.boton-dorado {
    font-family: "Playfair Display", Georgia, serif;
    font-style: italic;
    font-weight: 500;
    border-radius: 7px;
    color: #000;
    display: inline-block;
    font-size: 18px;
    line-height: 24px;
    padding: 12px 20px 15px;
    transition: 0.5s;
    text-align: center;
    transition: 0.5s;
    background-color: #b39a66;
    border: 2px solid #b39a66;
}

.boton-dorado::after {
    background-image: url(/img/icono-flecha-derecha-negro.svg);
}

.boton-dorado:hover,
.boton-dorado:focus {
    background-color: rgba(51, 158, 136, 0);
    color: #000000;
}

.boton-dorado:hover::after,
.boton-dorado:focus::after {
    background-image: url(/img/icono-flecha-derecha-negro.svg);
}

@media (min-width: 1200px) {
    h1 {
        font-size: 64px;
        line-height: 75px;
    }
    .hero-home-slider__item h2 {
        line-height: 1em;
        font-size: 1.5em;
    }
}

@media (min-width: 768px) {
    .hero-home-slider__item h2 {
        line-height: 1em;
        font-size: 1.5em;
    }
}

@media (max-width: 700px) {

    .hero-home-slider__item h2 {
        line-height: 1em;
        font-size: 1.5em;
    }

    .carousel__next {
        top: auto !important;
        right: 0px !important;
        transform: inherit;
        left: auto !important;
        bottom: 0px;
    }

    .carousel__prev {
        top: auto !important;
        right: 32px !important;
        transform: inherit;
        left: auto !important;
        bottom: 0px;
    }
}
</style>
